export const DEFAULT_WEBSITE_CRAWL_CREDIT_RATE_PER_PAGE = 0.1
